interface JwtPayload {
  sub?: string;
  vendorId?: string;
  role?: string;
  exp?: number;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const pad = parts[1] + '='.repeat((4 - (parts[1].length % 4)) % 4);
    const base64 = pad.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function getVendorIdFromToken(): string | null {
  const token = localStorage.getItem('vendor_token');
  if (!token) return null;
  return decodeJwt(token)?.vendorId ?? null;
}

const STOREFRONT_URL = (import.meta.env.VITE_STOREFRONT_URL as string | undefined) ?? 'http://localhost:3000';

export async function uploadImage(file: File): Promise<string> {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${STOREFRONT_URL}/api/cms/upload`, { method: 'POST', body: fd });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? `Upload failed (HTTP ${res.status})`);
  }
  const { url } = (await res.json()) as { url: string };
  return url.startsWith('http') ? url : `${STOREFRONT_URL}${url}`;
}
